import React, { useState } from "react";
import "./SearchBar.css";
import { Search } from "lucide-react";
import { X } from "lucide-react";
import style from "./SearchBar.module.scss";
/**
 *
 * @param {Object} props - component property.
 * @param {Function} props.setSearchtext - function to update the search query
 * @returns {JSX.Element} - a searchbar with input field and search icon
 * @author - Susovan Mishra ; susovanm@ovaku.in
 */
function SearchBar({ searchText, setSearchText }) {
  return (
    <div className="p-3">
      {/* Searching component for searching items */}
      <div className={`${style.searchInputContainer} position-relative`}>
        <Search className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
        {/* 
        Props:
        - setSearchText: Function to update the search text (setter function).
      */}
        <input
          //Changes the searching query in the input
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
          type="text"
          className={`${style.searchInput} w-100 rounded-pill ser-in px-4 ps-5 pe-5`}
          placeholder="Search your favourite food"
        />
        {searchText && (
          <X
            onClick={() => setSearchText("")}
            className={`${style.XClick} md-end-50 position-absolute top-50 end-0 translate-middle-y me-3 text-muted cursor-pointer`}
          />
        )}
      </div>
    </div>
  );
}

export default SearchBar;
